import IMemberPricing from "../contracts/IMemberPricing";
import PricingHandler from "../contracts/PricingHandler";

/**
 * Assigns price to p5 if a user has a qualifying membership.
 *
 * @param input
 * @param resolvedPricing
 */
const memberHandler: PricingHandler<IMemberPricing> = (
  input,
  resolvedPricing,
) => {
  if (
    !input.user.hasWebPlus ||
    !input.p5 ||
    input.p5 >= resolvedPricing.price
  ) {
    return resolvedPricing;
  }

  return {
    ...resolvedPricing,
    memberPricing: input.p5,
  };
};

export default memberHandler;
